<template>
  <v-app id="main" :style="{background: $vuetify.theme.themes[theme].background}">
    <NavBar />
    <v-main>
      <router-view></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>

export default {
  name: "App",
  components:{ 
    		NavBar: () => import('./components/NavBar'), 
        Footer: () => import('./components/Footer.vue'),
  },
   computed:{
    theme() {
      return (this.$vuetify.theme.dark) ? 'dark' : 'dark'
    }
  }
};

</script>
<style >

.v-menu__content.theme--light::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.v-menu__content.theme--light::-webkit-scrollbar-track {
    background: #dddddd;
}

.v-menu__content.theme--light::-webkit-scrollbar-thumb {
    background: #b0b0b0;
}

.v-menu__content.theme--light::-webkit-scrollbar-thumb:hover {
    background: grey;
}

.v-application 
.v-label{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px !important;
 }

 
.theme--dark.v-card{
    background-color: #222227;
}
</style>
